

export default {
  name: "Header",
  created() {
    window.addEventListener("resize", this.resizeHeader);
  },
  mounted() {
    window.menuInit();
  },
  methods: {
    smallNavClose: function() {
      this.$refs.btnNavRef.setAttribute("class", "btn_nav");
      this.$refs.navRef.setAttribute("style", "display: none;");
    },
    largeNavShow : function() {
      this.$refs.btnNavRef.setAttribute("class", "btn_nav open");
      this.$refs.navRef.setAttribute("style", "display: block;");
    },
    resizeHeader() {
      if (window.innerWidth >= 1200) {
        this.largeNavShow();
      } else {
        this.smallNavClose();
      }
    },
    navBtnClick: function() {
      if (window.innerWidth < 1200) {
        if (this.$refs.btnNavRef.getAttribute("class").indexOf("open") !== -1) {
          this.smallNavClose();
        } else {
          this.largeNavShow();
        }
      }
    }
  }
};
